import Vue from 'vue';
import currencyFilter from './currencyFilter';
import dateFilter from './dateFilter';
import codeListValueFilter from './codeListValueFilter';
import translate from './translateFilter';

export default () => {
  Vue.filter('currency', currencyFilter);
  Vue.filter('date', dateFilter);
  Vue.filter('codeListValue', codeListValueFilter);
  Vue.filter('translate', translate);
};



// WEBPACK FOOTER //
// ./client/filters/index.js